module.exports = __webpack_public_path__ + "img/utilityhydrant_parked.c90126c5.svg";